import {fileInputType, FileInputViewRenderer} from './viewFiles'

class CustomFormFields {
    constructor(formFields) {
      formFields.register(fileInputType, FileInputViewRenderer);
    }
  }
  
  export default {
    __init__: ['viewerFile'],
    viewerFile: ['type', CustomFormFields]
  };